/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Member_Roles_WriteInputs */



/**
* | output |
* | --- |
* | "Approve, deny and reset personal roles" |
*
* @param {Perm_Product_Leveling_Member_Roles_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_member_roles_write = /** @type {((inputs?: Perm_Product_Leveling_Member_Roles_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Member_Roles_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрять, отклонять и сбрасывать личные роли")
	return /** @type {LocalizedString} */ ("Approve, deny and reset personal roles")
});